module.exports = __webpack_public_path__ + "static/img/元生平台_文字_png@2x.c47ffdb7.png";